import React from 'react';

import { Point3D, RenderOrder } from '@paragon/three-shared';

interface Props {
  readonly color?: string;
  readonly fontHeight?: number;
  readonly labelText: string;
  readonly position: Point3D;
  readonly size?: number;
}

export default function LabelVisual(props: Props) {
  const { color, fontHeight, labelText, position, size } = props;

  const image = React.useMemo(() => {
    const canvas = document.createElement('canvas');
    const canvasSize = 512; // Three.js Texture must be square
    canvas.width = canvasSize;
    canvas.height = canvasSize;

    const context = canvas.getContext('2d')!;

    context.font = `${fontHeight || 100}px Roboto`;
    context.textAlign = 'center';

    const textColor = color || '#ffffff';
    context.fillStyle = textColor;
    context.lineWidth = 4;
    // if hex value is close to white -> black outline, else white
    context.strokeStyle = parseInt(textColor.substring(1, textColor.length), 16) > 0xfffff9 ? 'black' : 'white';

    context.fillText(labelText, canvasSize / 2, canvasSize / 2);
    context.lineWidth = 2;
    context.strokeText(labelText, canvasSize / 2, canvasSize / 2);

    return canvas;
  }, [color, fontHeight, labelText]);

  const scale = size || 10;
  return (
    <sprite
      position={[position.x, position.y, position.z]}
      scale={[scale, scale, 1]}
      renderOrder={RenderOrder.LabelVisual}
    >
      <spriteMaterial attach="material" depthTest={false}>
        <canvasTexture
          attach="map"
          args={[image]}
          anisotropy={3}
          onUpdate={(s) => {
            s.needsUpdate = true;
          }}
        />
      </spriteMaterial>
    </sprite>
  );
}
